import { CircularProgress, type CircularProgressProps } from '@mui/material'

type Props = Pick<CircularProgressProps, 'sx' | 'size' | 'color'>

/**
 * for now, internal use only
 */
export const LoadingIndicator = ({ sx, color = 'inherit', size = 16 }: Props) => (
  <CircularProgress color={color} size={size} data-chromatic="ignore" aria-label="loading" sx={sx} />
)
